import { createCrudSlice, createCrudSliceSelectors } from '@/store/util';

import {
  indexAccountIntegrations,
  newAccountIntegration,
  createAccountIntegration,
  editAccountIntegration,
  updateAccountIntegration,
} from './actions';

const options = {
  name: 'accountIntegrations',
  collectionName: 'account_integrations',
  recordName: 'account_integration',
  actionsConfig: {
    index: {
      read: indexAccountIntegrations,
    },
    create: {
      read: newAccountIntegration,
      write: createAccountIntegration,
    },
    update: {
      read: editAccountIntegration,
      write: updateAccountIntegration,
    },
  },
};

export const {
  index: selectAccountIntegrations,
  create: selectAccountIntegrationForCreate,
  update: selectAccountIntegrationForUpdate,
} = createCrudSliceSelectors(options);

const { reducer } = createCrudSlice(options);
export default reducer;
